export const dynamic = {
    cards: "Cards",
    digitalCarousel: "DigitalCarousel",
    iconTilesSection: "IconTiles",
    testimonialsSection: "Testimonials",
    row: "ContentRow",
    column: "ColumnCopy"
};

export const local = [
    "ArticlePost",
    "ArticlePostsList",
    "CookiePreferences",
    "CityLinks",
    "ContactUsToggleCards",
    "InquiryThankYou",
    "ShareButtons",
];
